import React from 'react';

interface SvgChevronProps {
  color?: string;
  width?: number;
  height?: number;
}

const SvgChevron: React.FC<SvgChevronProps> = ({
  color = '#292D32',
  width = 24,
  height = 24
}) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 9L12 15L18 9" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default SvgChevron; 